// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"ZoomControls_iconButton__9xUlt","button":"ZoomControls_button__ysOyG"};